module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-14.e4b94073.png";